import React from 'react';

import Error from '../../error/components/Error';

import error404Svg from '../../../assets/images/Error404.svg';

export default function Notfound() {
  return (
    <Error
      description={'client_error404_description'}
      image={error404Svg}
      meta={{
        description: 'client_error404_mete_description',
        keywords:    'default_meta_keywords',
        title:       'client_error404_meta_title',
      }}
      title={'client_error404_title'}
    />);
};